import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search", "list", "item"]

  filter() {
    const query = this.searchTarget.value.toLowerCase().trim()
    this.itemTargets.forEach(item => {
      const name = (item.dataset.clientName || "").toLowerCase()
      item.classList.toggle("hidden", query.length > 0 && !name.includes(query))
    })
  }
}
